/**
 * Analytics types for GenAI Studio v2
 */

// Screen action types
export enum AiGenScreenAction {
  GENERATE = 'generate',
  GENERATE_CLICK = 'generate_click',
  RETRY = 'retry',
  DISMISS_ERROR = 'dismiss_error',
  UPLOAD = 'upload',
  UPLOAD_CLICK = 'upload_click',
  UPLOAD_FAILURE = 'upload_failure',
  DOWNLOAD = 'download',
  CANCEL = 'cancel',
  EDIT = 'edit',
  BACK = 'back',
  CLICK = 'click',
  SHARE = 'share',
  DELETE = 'delete',
  REPORT = 'report',
  REUSE_TEMPLATE = 'reuse_template',
  LIKE = 'like',
  DISLIKE = 'dislike',
  TRENDING_ITEM_CLICK = 'trending_item_click',
  CHIP_CLICK = 'chip_click',
  SEE_ALL = 'see_all',
  OPEN = 'feed_open',
  SWIPE_UP = 'swipe_up',
  SWIPE_DOWN = 'swipe_down',
  PROFILE_OPEN = 'profile_open',
  CREDITS_OPEN = 'credits_open',
  GET_MORE = 'get_more',
  SAVE = 'save',
  UNSAVE = 'unsave',
  STREAK_CLICK = 'streak_click',
  STREAK_AUTO_OPEN = 'streak_auto_open',
  STREAK_SHEET_OPEN = 'streak_sheet_open',
  STREAK_SHEET_CLOSE = 'streak_sheet_close',
  STREAK_CLAIM = 'streak_claim',
  STREAK_CLAIM_EARLY = 'streak_claim_early',
  STREAK_CLAIM_FAIL = 'streak_claim_fail',
  STREAK_COMPLETE = 'streak_complete',
  SEARCH_OPEN = 'search_open',
  SEARCH_CLOSE = 'search_close',
  SEARCH_SUBMIT = 'search_submit',
  SEARCH_RESULT_SEEN = 'search_result_seen',
  SEARCH_RESULT_CLICK = 'search_result_click',
  SEARCH_RECENT_CLICK = 'search_recent_click',
}

// Screen type values
export enum ScreenType {
  GENERATOR = 'generator_screen',
  CHOOSER = 'chooser_screen',
  HISTORY = 'history',
  PREVIEW = 'preview_screen',
  PRESET_FEED = 'preset_feed',
  PROFILE = 'profile',
  CREDITS = 'credits',
  SEARCH = 'search',
}

// Entry point for the preset feed open event
export type PresetFeedOpenSource = 'click' | 'deeplink';

export enum ClickItem {
  Category = 'category',
  Effect = 'effect',
  Tool = 'tool',
  Edit = 'edit',
}

// Settings object for analytics
export interface AnalyticsSettings {
  category?: string;
  tool?: string;
  id?: string;
  error_message?: string;
  remaining_seconds?: number;
  day?: number;
  /** Normalized search term (`formatSearchKeyword`), on the search events. */
  keyword?: string;
  /** Hits returned for `keyword`; 0 means the query matched nothing. */
  results_count?: number;
  /** 1-based rank of the clicked result within the list it was clicked from. */
  position?: number;
}

// Extended settings for failure cases (error fields required)
export interface AnalyticsSettingsWithError extends AnalyticsSettings {
  error_type: string;
  error_message: string;
}
